export const url = "https://srv531466.hstgr.cloud";

//http://localhost:5000
//https://telu-project.vercel.app
//https://srv531466.hstgr.cloud/
